import { map, get, flow } from 'lodash/fp';
import { createSelector, createStructuredSelector } from 'reselect';
import { options as priceOptions } from 'helpers/fieldOptions/ad/price';
import { formatMoney } from 'helpers/i18n';
import { getMinMaxOptions } from 'helpers/fieldOptions';

const getOptions = createSelector(
  createStructuredSelector({
    options: () => priceOptions,
    value: get(['value']),
    type: get(['rangeType']),
  }),
  flow(
    ({ options, value, type }) =>
      type ? getMinMaxOptions({ options, value, type }) : options,
    map((item) => ({ ...item, label: formatMoney(item.label) })),
  ),
);

export default {
  clearable: () => true,
  options: getOptions,
  placeholder: () => __('search.filters.any'),
};
